import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { PostArenaSubmissionModuleName } from '@/store/modules/modules'

export class PostArenaSubmissionViewModel {
  private store = useStore()

  judgeToken: ComputedRef<string> = computed(() => this.store.getters[`${PostArenaSubmissionModuleName}/judgeToken`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${PostArenaSubmissionModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${PostArenaSubmissionModuleName}/error`])

  async postArenaSubmission(
    problemId: string,
    arenaProblemId: string,
    arenaId: string,
    programLanguage: ProgramLanguageType,
    sourceCode: string
  ): Promise<void> {
    await this.store.dispatch(`${PostArenaSubmissionModuleName}/postArenaSubmission`, {
      problemId,
      arenaProblemId,
      arenaId,
      programLanguage,
      sourceCode
    })
  }
}
